import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook to track page changes and trigger Google Analytics events
 * This hook should be used at the router level to track all page navigation
 * Logic:
 * - If pathname is different than historical pathname, then trigger ga_trigger
 */
export const usePageTracking = () => {
  const location = useLocation();
  const historicalPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    if (historicalPathnameRef.current !== location.pathname) {
      const eventData = {
        event: "ga_trigger",
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        page_title: document.title,
      };
      if (window.dataLayer) {
        window.dataLayer.push(eventData);
      }
      historicalPathnameRef.current = location.pathname;
    }
  }, [location.pathname, location.search]);
};

export default usePageTracking;
